<template>
  <!--我的账单详情-->
  <div class="page-box">
    <h4 class="page-box__title">账单详情</h4>

    <el-form class=""
             label-width="140px"
             @submit.native.prevent>
      <el-row>
        <el-col :span="8">
          <el-form-item label="账单号：">{{id}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="账单金额：">{{details.sumamount}} {{details.currency||''}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="账期：">{{details.paymentdays}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="对账日期：">{{details.billCheckTime}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="账单产生时间：">{{details.billnumberTime}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table :data="tableData"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              size="mini"
              highlight-current-row
              style="width: 100%;"
              border>
      <el-table-column label="序号"
                       type="index"
                       align="center"
                       width="60"></el-table-column>
      <el-table-column label="运单号"
                       align="center"
                       min-width="130"
                       prop="nos"></el-table-column>
      <el-table-column label="主单号"
                       align="center"
                       min-width="130"
                       prop="mainnos"></el-table-column>
      <el-table-column label="费用名称"
                       align="center"
                       width="130"
                       prop="feeitemdec"></el-table-column>
      <el-table-column label="费用状态"
                       align="center"
                       width="80"
                       prop="processstatusdec"></el-table-column>
      <el-table-column label="费用产生时间"
                       align="center"
                       width="110"
                       prop="arapdate"></el-table-column>
      <el-table-column label="实际数量"
                       align="center"
                       width="80"
                       prop="actualPiece"></el-table-column>
      <el-table-column label="计费数量"
                       align="center"
                       width="80"
                       prop="piece"></el-table-column>
      <el-table-column label="单位"
                       align="center"
                       width="80"
                       prop="unit"></el-table-column>
      <el-table-column label="单价"
                       align="center"
                       width="100"
                       prop="pricenotax"></el-table-column>
      <el-table-column label="费用金额"
                       align="center"
                       min-width="100"
                       prop="amount">
        <template slot-scope="scope">
          {{scope.row.amount||''}} {{scope.row.currency||''}}
        </template>
      </el-table-column>
      <el-table-column label="折合人名币"
                       align="center"
                       min-width="100"
                       prop="cnyAmount"></el-table-column>
      <el-table-column label="计费过程"
                       align="center"
                       min-width="130"
                       prop="calDesc"></el-table-column>
      <el-table-column label="备注"
                       align="center"
                       min-width="130"
                       prop="remarks"></el-table-column>
    </el-table>

    <div class="margin-tb-sm"
         style="text-align: center">
      <el-button type=""
                 icon="el-icon-back"
                 style="margin-top:40px;min-width: 120px;"
                 @click="$router.back()">返回</el-button>
    </div>
  </div>

</template>

<script>
  export default {
    name: "myBillDetails",
    data(){
      return{
        id:'',
        tableData:[],
        details:{},

      }
    },
    created(value) {
      let id = this.id = this.$route.query.id;
      this.getBillDetails();
      this.getBillChildrenList();
    },
    methods:{
      /**
       * 根据账单号 请求账单列表 获得账单详情
       */
      getBillDetails(id = this.id){
        if(!id) return this.$message.error('ID为空');
        let data = {
          billnumber:id,
        };
        this.loading = true;
        return new Promise((resolve, reject) => {
          this.axios.post('/arapcost/getMyBillList', data)
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.details = {};
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              if(res.data.datas.length){
                this.details = res.data.datas[0];
              }
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
              this.details = {};
            });
        })
      },
      /**
       * 根据账单号 请求账单详情子单列表
       */
      getBillChildrenList(id = this.id){
        if(!id) return this.$message.error('ID为空');
        let data = {
          billnumber:id,
        };
        return new Promise((resolve, reject) => {
          this.loading = true;
          this.axios.post('/arapcost/getMyBillDetailsList',this.qs.stringify(data),{
            // headers:{"Content-Type":"application/json",},
          })
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.tableData = [];
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.tableData = res.data.datas;
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
              this.tableData = [];
            });
        })
      },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/financialManagement/myBillDetails.vue